import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import BaseItem from "./BaseItem";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, iconNode, reactifiedIcon, narrow, rehydratedProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("GlobalHeaderBaseItem");
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "contentInner"
            })));

            if (!childrenNode) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return rehydrateChildren(childrenNode);

          case 5:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 8:
            _context.t0 = null;

          case 9:
            reactifiedChildren = _context.t0;
            iconNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "linkIcon"
            })));

            if (!iconNode) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return rehydrateChildren(iconNode);

          case 14:
            _context.t1 = _context.sent;
            _context.next = 18;
            break;

          case 17:
            _context.t1 = null;

          case 18:
            reactifiedIcon = _context.t1;
            narrow = domNode.getAttribute("data-narrow");
            rehydratedProps = {
              icon: reactifiedIcon,
              href: domNode.getAttribute("data-href"),
              label: domNode.getAttribute("data-label"),
              ariaLabel: domNode.getAttribute("data-ariaLabel"),
              longLabel: domNode.getAttribute("data-long-label"),
              linkLanguage: domNode.getAttribute("data-link-language"),
              narrow: narrow === "true"
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(BaseItem, rehydratedProps, reactifiedChildren));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();